// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
  background-color: #fff;
  margin: 0px;
  padding: 0px;
  width: 100%;
  display: block;
  overflow: auto;
  min-height: 100vh;
}

.App {
  display: flex;
  color: #000;
  height: 100%;
  flex-direction: column;
  overflow-y: auto;
}
.App.bga {
  background-color: rgb(245, 247, 248);
}
.App.afap {
  min-height: 100vh;
}
.App .App-header {
  height: 75px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  font-size: calc(10px + 2vmin);
  color: white;
}
.App .App-header .App-logo {
  height: 52px;
  width: 193px;
  cursor: pointer;
}
.App .App-header.wel {
  padding-left: 90px;
}
.App h1.mainh {
  font-family: "Inter";
  font-weight: 600;
  font-size: 40px;
  margin: 0px !important;
  line-height: 50px;
}
.App h1.mainh.bb {
  font-weight: bolder;
}
.App h1.mainh.b2 {
  margin-bottom: 25px !important;
}
.App .err-msg {
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-family: "Inter";
  margin-top: 0.5em;
  padding-top: 4px;
  padding-bottom: 4px;
  color: #fff;
  max-width: 600px;
  font-size: 14px;
  font-weight: bold;
  background-color: #d73030;
  border-radius: 4px;
}
.App .err-msg.alt {
  color: #d73030;
  background-color: #fff;
}
.App h3.mainh {
  margin-bottom: 30px;
  font-size: 30px;
  font-weight: bolder;
  margin-left: 10px;
}
.App h4.mainh {
  font-size: 32px;
  font-weight: 500;
  margin-left: 0px;
  margin-bottom: 30px;
}
.App .mainh.cn {
  text-align: center;
}
.App .ebn {
  width: 75%;
  max-width: 800px;
  max-width: 600px;
  /* min-width: 550px; */
  border-radius: 6px;
  height: 60px;
  outline: none;
  font-size: 16px;
  margin-top: 25px;
  text-align: center;
  background-color: transparent;
  border: 1px solid #DDD;
}
.App .clogos {
  display: flex;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.App .clogos img {
  height: 35px;
  margin-left: 1em;
  margin-right: 1em;
}
.App .pp-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.App .pp-body.cn {
  width: 100%;
  padding-top: 120px;
  align-items: center;
}
.App .ssfy {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 1em;
  margin-bottom: 1em;
}
.App .ssfy button {
  background-color: #5f7380;
  color: #fff;
  border-radius: 40px;
  font-size: 14px;
  margin: 4px 8px;
  border: 1px solid #20134b;
  height: 40px;
  padding-left: 14px;
  padding-right: 14px;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  cursor: pointer;
}
.App .ssfy button:hover {
  background-color: #353e44;
}
.App .cu-product {
  display: flex;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
}
.App .cu-product .cu-main {
  display: inline-flex;
  width: 62%;
  flex-direction: column;
}
.App .cu-product .cu-main > div {
  display: flex;
  width: 100%;
}
.App .cu-product .cu-head {
  display: flex;
  flex-direction: row;
  padding: 1em 1em 0 1em;
}
.App .cu-product .cu-head > div {
  display: inline-flex;
  flex-direction: column;
  padding: 5px;
  color: #999EA1;
  font-size: 14px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
.App .cu-product .cu-head > div._1 {
  color: #000;
}
.App .cu-product .cu-right {
  display: inline-flex;
  flex-direction: column;
  width: 37%;
  padding: 1em 5px;
}
.App .cu-product .cu-right .cu-il {
  width: 45px;
  border-radius: 4px;
  margin-right: 1em;
  border: 1px solid #E0E0E0;
}
.App .cu-product .cu-right .cu-ds {
  font-size: 16px;
}
.App .cu-product .cu-right .cu-h, .App .cu-product .cu-right .cu-sh {
  color: #151515;
  font-size: 28px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bolder;
}
.App .cu-product .cu-right .cu-sh {
  font-size: 20px;
}
.App .cu-product .cu-right .cu-rw {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EEEEEE;
}
.App .cu-product .cu-right .cu-rw.rw {
  display: flex;
  flex-direction: row;
}
.App .cu-product .cu-right .btn-rw {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;
  justify-content: space-between;
  align-items: center;
}
.App .cu-product .cu-right .btn-default {
  border: 1px solid #151515;
  width: 152px;
  height: 37px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.App .cu-product .cu-right .btn-default img {
  width: 16px;
  margin-right: 8px;
}
.App .cu-product .cu-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
}
.App .cu-product .cu-body .ib-m {
  margin: 25px;
  height: 420px;
}
.App .cu-product .cu-body .itl-1, .App .cu-product .cu-body .itl-2 {
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  cursor: pointer;
  box-shadow: 1px 2px 3px #DDD;
  border: 1px solid #DDD;
}
.App .cu-product .cu-body .itl-1 {
  position: absolute;
  background: #F6F6F6;
  left: 25px;
  top: 25px;
}
.App .cu-product .cu-body .itl-2 {
  position: absolute;
  background: #2D9CDB;
  left: 25px;
  top: 85px;
}
.App .cu-product .clr {
  background: #DDD;
  margin: 5px;
  border-radius: 50px;
  width: 20px;
  cursor: pointer;
  height: 20px;
}
.App .cu-product .clr._1 {
  background: #FB891F;
}
.App .cu-product .clr._2 {
  background: #FB1F1F;
}
.App .cu-product .clr._3 {
  background: #C0F000;
}
.App .cu-product .clr._4 {
  background: #83D61A;
}
.App .cu-product .clr._5 {
  background: #1FD3FB;
}
.App .cu-product .clr._6 {
  background: #1958B6;
}
.App .cu-product .clr._7 {
  background: #661FFB;
}
.App .cu-product .clr._8 {
  background: #590EA5;
}
.App .cu-product .clr._9 {
  background: #4F2F00;
}
.App .cu-product .clr._10 {
  background: #000000;
}
.App .cu-product .cut {
  display: flex;
  flex-direction: row;
  padding: 5px 10px;
  background: #FCF6EA;
  border-radius: 4px;
  color: #C89435;
  cursor: pointer;
}
.App .cnp-tab {
  display: flex;
  flex-direction: column;
}
.App .cnp-tab .cnp-rw {
  width: 100%;
  display: row;
  display: flex;
}
.App .cnp-tab .cnp-rw.f {
  align-self: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  flex: 1 1;
}
.App .cnp-tab .cnp-rw .cnp-it {
  text-decoration: none !important;
  background-color: #ddd;
  color: #000 !important;
  border-radius: 4px;
  height: 270px;
  width: 270px;
  margin: 10px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
.App .cnp-tab .cnp-rw .cnp-it span {
  font-size: 22px;
  font-weight: bolder;
  text-align: center;
}
.App .cnp-tab .cnp-rw .cnp-it.h {
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: calc(33% - 20px);
}
.App .cnp-tab .cnp-rw .cnp-it.t {
  background: transparent;
}
.App .cnp-tab .cnp-rw .c1 {
  background-color: rgba(18, 177, 150, 0.05);
}
.App .cnp-tab .cnp-rw .c2 {
  background-color: rgba(23, 20, 35, 0.05);
}
.App .cnp-tab .cnp-rw .c3 {
  background-color: rgba(246, 173, 77, 0.19);
}
.App .cnp-tab .cnp-rw .c4 {
  background-color: rgba(23, 20, 35, 0.07);
}
.App .cnp-tab .cnp-rw .c5 {
  background-color: rgba(246, 173, 77, 0.19);
}
.App .cnp-tab .cnp-rw .c6 {
  background-color: rgba(18, 177, 150, 0.07);
}
.App .cnp-tab .cnp-rw .c7 {
  background-color: rgba(18, 177, 150, 0.07);
}
.App .cnp-tab .cnp-rw .c8 {
  background-color: rgba(23, 20, 35, 0.07);
}
.App .cnp-tab.alt .cnp-it {
  width: 400px;
  height: 130px;
  margin-bottom: 2em;
  border-radius: 1em;
  position: relative;
  flex-direction: row;
  border: 1px solid #DDD;
  background-color: #fff;
  justify-content: space-between;
}
.App .cnp-tab.alt .cnp-it span {
  margin-left: 1em;
}
.App .cnp-tab.alt .cnp-it img {
  height: 100%;
}
.App .cnp-tab.alt .cnp-it.n1 {
  margin-right: 1em;
}
.App .cnp-tab.alt .cnp-it.n2 {
  margin-left: 1em;
}
.App .cnp-tab.alt-2 {
  margin-bottom: 30px;
}
.App .cnp-tab.alt-2 .cnp-it {
  flex-direction: column;
  background-color: #fff;
  height: auto;
  width: 300px;
  justify-content: flex-start;
}
.App .cnp-tab.alt-2 .cnp-it.t1 {
  margin-right: 20px;
}
.App .cnp-tab.alt-2 .cnp-it.t2 {
  margin-left: 20px;
  margin-right: 20px;
}
.App .cnp-tab.alt-2 .cnp-it.t3 {
  margin-left: 20px;
}
.App .cnp-tab.alt-2 .cnp-it img {
  width: 100%;
}
.App .cnp-tab.alt-2 .cnp-it strong {
  color: #000;
  text-align: left;
  font-size: 16px;
  width: 100%;
  padding: 5px 15px;
}
.App .cnp-tab.alt-2 .cnp-it > div {
  width: calc(100% - 30px);
  margin-left: 15px;
  margin-right: 15px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-top: 1px solid #DDD;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.App .cnp-tab.alt-2 .cnp-it > div span {
  font-size: 16px;
  color: rgb(153, 158, 161);
  font-weight: normal;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
}
.App .cnp-tab.alt-2 .cnp-it > div span img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.App .cnp-tab.alt-2 .cnp-it > div.alt {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.App .cnp-tab.alt-2 .cnp-it > div.alt b {
  font-size: 14px;
  margin-top: 3px;
}
.App .cnp-tab.alt-2 .cnp-it > div.alt span {
  display: flex;
  font-size: 14px;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.App .cnp-tab.alt-2 .cnp-it > div.alt span img {
  width: 14px;
  height: 14px;
}
.App .btn-next {
  background: #12B196;
  height: 45px;
  width: 153px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #fff !important;
  font-size: 16px;
  margin: 10px 0 15px 0;
  border-radius: 4px;
  text-decoration: none;
  border: 1px solid transparent;
}
.App .wec0 {
  position: relative;
  width: 50vw;
  padding: 50px 90px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.App .wec0 p {
  font-size: 18px;
  margin-bottom: 25px;
}
.App .wec0 p.clst {
  display: flex;
  flex-direction: column;
}
.App .wec0 p.clst span {
  margin-top: 10px;
}
.App .wec0.alt {
  padding-left: 120px;
}
.App .bc-ro {
  position: absolute;
  top: 100px;
  width: 210px;
  left: calc(50vw - 105px);
}
.App .bc-ma {
  position: absolute;
  width: 100vw;
  bottom: 100px;
  color: #fff;
  height: 50px;
  display: flex;
  font-size: 20px;
  justify-content: center;
  align-items: center;
  background: #c16bab;
}
.App .fright {
  width: 650px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.App .wec1 {
  background: #91bdb9;
  width: 50vw;
  min-width: fit-content;
  display: flex;
  position: absolute;
  right: 0px;
  top: 0px;
  flex-direction: row;
  justify-content: center;
  background-image: linear-gradient(to right, #91bdb9, #99c5c9);
}
.App .wec1 .we1 {
  height: 100vh;
}
.App .wec1.alt {
  background-image: linear-gradient(to right, #fff, #f8f9fa);
}
.App .App-body {
  display: flex;
  padding-top: 25px;
  padding-bottom: 50px;
  flex-direction: row;
  min-width: 1024px;
  justify-content: center;
}
.App .App-body.flex-col {
  flex-direction: column;
  justify-content: unset;
  align-items: center;
}
.App .App-body .pg {
  display: flex;
  color: #104FB8 !important;
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 0px;
  text-decoration: none !important;
  cursor: pointer;
}
.App .App-body .pg.cn {
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.App .App-body .pg.ri {
  width: 100%;
  text-align: right;
  justify-content: flex-end;
}
.App .App-body.main-body {
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.App .App-body.main-body.cr {
  align-items: center;
}
.App .App-body.full {
  min-height: calc(100vh - 75px);
}
.App .App-body .sign-p {
  width: 90%;
  max-width: 600px;
  padding-left: 1em;
  padding-right: 1em;
  text-align: center;
  font-size: 18px;
  margin-bottom: 25px;
}
.App .App-body .g-steps {
  display: flex;
  width: 320px;
  justify-content: space-between;
  flex-direction: row;
  position: relative;
  z-index: 1;
  margin-bottom: 40px;
}
.App .App-body .g-steps::before {
  content: "";
  width: 100%;
  height: 2px;
  background: #999EA1;
  z-index: -1;
  left: 0px;
  top: 17px;
  position: absolute;
}
.App .App-body .g-steps .g-step {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  position: relative;
  border: 2px solid #999EA1;
}
.App .App-body .g-steps .g-step div.g-st {
  width: 12px;
  height: 12px;
  background: #999EA1;
  border-radius: 50%;
}
.App .App-body .g-steps .g-step img.g-st {
  display: none;
}
.App .App-body .g-steps .g-step span {
  position: absolute;
  top: 37px;
  font-size: 14px;
}
.App .App-body .g-steps .g-step:hover, .App .App-body .g-steps .g-step._active {
  background: #12B196;
  border-color: #12B196;
}
.App .App-body .g-steps .g-step:hover img.g-st, .App .App-body .g-steps .g-step._active img.g-st {
  width: 14px;
  display: block;
}
.App .App-body .g-steps .g-step:hover div.g-st, .App .App-body .g-steps .g-step._active div.g-st {
  display: none;
}
.App .App-body .gsv-foot {
  width: 870px;
  display: flex;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-direction: column;
}
.App .App-body .gsv-foot.cst {
  width: 950px;
}
.App .App-body .gsv-foot .btn-next {
  position: absolute;
  right: 0px;
  top: 0px;
}
.App .App-body .gsv-foot h2 {
  font-weight: bolder;
  position: relative;
  display: block;
  font-size: 32px;
  width: fit-content;
  padding-right: 10px;
}
.App .App-body .gsv-foot h2 small {
  position: absolute;
  font-size: 25px;
  color: red;
  right: -2px;
  top: 0px;
}
.App .App-body .gsv-foot p {
  position: relative;
  padding-left: 1em;
}
.App .App-body .gsv-foot p small {
  position: absolute;
  font-size: 20px;
  color: red;
  left: 0px;
  top: -2px;
}
.App .App-body .gsv-foot span {
  color: #999EA1;
}
.App .App-body .gsv-cover {
  width: 870px;
  display: flex;
  flex-direction: column;
  background: #F6F6F6;
  align-items: center;
  border-radius: 10px;
}
.App .App-body .gsv-cover.cst {
  width: 950px;
  height: 550px;
  background-color: #fff;
}
.App .App-body .gsv-cover.ulogo {
  justify-content: center;
  border-radius: 25px;
  margin-top: 40px;
  height: 300px;
  width: 650px;
}
.App .App-body .gsv-cover.ulogo.im {
  justify-content: flex-start;
  height: unset;
  padding-top: 2em;
  padding-bottom: 2em;
}
.App .App-body .gsv-cover.ulogo.im img {
  max-width: 90%;
  margin-bottom: 1em;
}
.App .App-body .gsv-cover.ulogo b {
  margin-top: 25px;
  color: #151515;
}
.App .App-body .gsv-cover.ulogo span {
  margin-top: 5px;
  color: #999EA1;
  font-size: 14px;
}
.App .App-body .gsv-cover.fill {
  background-color: #fff;
  justify-content: flex-start;
  border-radius: 8px;
  margin-top: 20px;
  width: 650px;
  padding: 20px;
  margin-bottom: 1em;
}
.App .App-body .gsv-cover.fill form {
  width: 100%;
}
.App .App-body .gsv-cover.fill form input {
  margin-top: 15px;
  height: 60px;
  margin-bottom: 15px;
}
.App .App-body .gsv-cover.fill.alt {
  height: 60px;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 20px;
}
.App .App-body .gsv-cover.fill.alt b {
  font-size: 25px;
  font-weight: 400;
}
.App .App-body .gsv-cover.fill.alt strong {
  font-size: 25px;
}
.App .App-body .gsv-cover .gsv {
  margin-top: 1em;
  margin-bottom: 1em;
  background-color: #373737;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  width: 833px;
  height: 390px;
}
.App .App-body .gsv-cover .gsv.y {
  height: auto;
  min-height: 400px;
  padding-top: 7px;
  border-radius: 10px;
  flex-direction: column;
}
.App .App-body .gsv-cover .gsv img {
  cursor: pointer;
}
.App .App-body .gsv-cover p {
  width: 833px;
}
.App .App-body .gsv-cover p.gsp {
  margin-top: 0.5em;
  font-size: 20px;
}
.App .App-body .gsv-cover p.gsp img {
  height: 40px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.App .App-body .rf-sect, .App .App-body .md-sect {
  display: inline-flex;
  flex-direction: column;
}
.App .App-body .rf-sect.step-1, .App .App-body .md-sect.step-1 {
  width: 600px;
  padding: 25px 100px;
  border: 1px solid #DDD;
}
.App .App-body .rf-sect {
  flex-direction: column;
  justify-content: center;
}
.App .App-body .rf-sect form {
  width: 400px;
}
.App .App-body .rf-sect form.rest-form {
  width: 500px;
}
.App .App-body .rf-sect form > * {
  margin-top: 1em;
  margin-bottom: 1em;
}
.App .App-body .rf-sect form label:not(.form-check-label) {
  font-family: "Inter";
  font-weight: 400;
  margin-bottom: 5px;
  font-size: 18px;
}
.App .App-body .rf-sect form input:not(.form-check-input) {
  height: 57px;
  border-radius: 4px;
  border: 1px solid #E0E0E0 !important;
}
.App .App-body .rf-sect form .form-check {
  margin-bottom: 0px;
}
.App .App-body .rf-sect form .submit-btn {
  height: 57px;
  margin-bottom: 0px;
  border-radius: 4px;
  background-color: #12B196;
  color: #fff;
  font-size: 18px;
  width: 100%;
}
.App .App-body .rf-sect form .submit-btn.btn-default {
  background-color: #fff;
  color: #000;
  border: 1px solid #999EA1;
}
.App .App-body .rf-sect form .submit-btn.btn-default .gvg {
  margin-right: 14px;
}
.App .App-body .md-sect {
  margin-left: 12%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.App .App-body .md-sect .md-sect-cover {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.App .App-body .md-sect .md-sect-cover .md-rw {
  width: 200px;
  height: 636px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
.App .App-body .md-sect .md-sect-cover .md-rw img {
  width: 183px;
  display: inline-flex;
}
.App form.for-step-0 .for-step-0 {
  display: inherit !important;
}
.App form.for-step-0 .for-step-1 {
  display: none !important;
}
.App form.for-step-1 .for-step-1 {
  display: inherit !important;
}
.App form.for-step-1 .for-step-0 {
  display: none !important;
}

.label {
  font-family: "Source Sans 3", sans-serif;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}

.fgroup {
  display: flex;
  margin: 10px 0px;
  height: 60px;
  border: 1px solid #DDD;
  padding-left: 10px;
  border-radius: 8px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.fgroup span.ftd {
  width: 50%;
  border-left: 1px solid #DDD;
  height: 100%;
  padding-left: 1.5em;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.modal-bg {
  background-color: rgba(187, 185, 185, 0.4);
  position: fixed;
  display: flex;
  bottom: 0px;
  right: 0px;
  left: 0px;
  top: 0px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.modal-bg .modal-pp {
  height: 500px;
  width: 1000px;
  max-width: 90%;
  padding: 2em;
  background: #fff;
  border: 1px solid #ddd;
  display: inline-flex;
  flex-direction: column;
  overflow: auto;
  box-shadow: 1px 2px 3px #868686;
}
.modal-bg .modal-pp .flex-contnt {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.modal-bg .modal-pp h2 {
  font-size: 35px;
  font-weight: bolder;
  margin-bottom: 0.7em;
}
.modal-bg .modal-pp p {
  font-size: 18px;
  margin-bottom: 0.9em;
}
.modal-bg .modal-pp .modal-ul {
  padding-left: 0px;
}
.modal-bg .modal-pp .modal-ul li {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.2em;
}
.modal-bg .modal-pp .modal-ul li > b, .modal-bg .modal-pp .modal-ul li > span {
  margin-bottom: 10px;
}
.modal-bg .modal-pp .modal-ul li > b {
  font-size: 18px;
}

iframe.onb-can {
  width: 100%;
  display: flex;
  height: 624px;
  border-top: 1px solid rgb(221, 221, 221);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
  background: #fff;
  border-bottom: 1px solid rgb(221, 221, 221);
}

iframe.dash-can {
  width: 100%;
  display: flex;
  height: 624px;
  border: 1px solid rgb(221, 221, 221);
  margin-top: 10px;
  background: #fff;
}

.tcent {
  text-align: center;
  width: 100%;
}

.rest-rect {
  width: 500px;
  display: flex;
  flex-direction: column;
  padding: 30px 70px;
  background-color: #F4F4F4;
  border-radius: 2em;
}
.rest-rect input {
  background-color: transparent;
}

.reset-pop-up {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.35);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000000000;
}
.reset-pop-up .reset-pop {
  width: 500px;
  padding: 50px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  background-color: #ddd;
}
.reset-pop-up .reset-pop img {
  cursor: pointer;
  background: #DDD;
  height: auto;
  width: 270px;
}
.reset-pop-up .reset-pop strong {
  text-align: center;
  font-size: 25px;
  margin-top: 25px;
}

.rest-form label {
  margin-top: 8px;
}

h4.tcent {
  font-weight: 600;
  margin-bottom: 20px;
}

p.tcent {
  font-weight: 400;
  font-size: 16px;
  padding: 5px 50px 10px;
}

.dash-can.pa {
  padding-top: 10px;
  padding-bottom: 10px;
}

#ulogo-preview {
  cursor: pointer;
  margin-bottom: 2em;
}
#ulogo-preview.alt {
  margin-bottom: 0px !important;
}

*::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,gBAAA;AAAJ;AAEI;EACI,oCAAA;AAAR;AAGI;EACI,iBAAA;AADR;AAII;EAEI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;AAHR;AAMQ;EACI,YAAA;EACA,YAAA;EACA,eAAA;AAJZ;AAMQ;EACI,kBAAA;AAJZ;AAQI;EACI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AANR;AAQQ;EACI,mBAAA;AANZ;AASQ;EACI,8BAAA;AAPZ;AAWI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AATR;AAUQ;EACI,cAAA;EACA,sBAAA;AARZ;AAYI;EACI,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAVR;AAaI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAXR;AAcI;EACI,kBAAA;AAZR;AAeI;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,sBAAA;AAbR;AAgBI;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AAdR;AAeQ;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;AAbZ;AAiBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAfR;AAgBQ;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;AAdZ;AAkBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAhBR;AA4BQ;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AA1BZ;AA4BY;EACI,yBAAA;AA1BhB;AAgCI;EACI,aAAA;EACA,8BAAA;EACA,sCAAA;EACA,kCAAA;AA9BR;AA+BQ;EACI,oBAAA;EACA,UAAA;EACA,sBAAA;AA7BZ;AA8BY;EACI,aAAA;EACA,WAAA;AA5BhB;AA+BQ;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AA7BZ;AA8BY;EACI,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AA5BhB;AA6BgB;EACI,WAAA;AA3BpB;AA+BQ;EACI,oBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AA7BZ;AA+BY;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AA7BhB;AA+BY;EACI,eAAA;AA7BhB;AA+BY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA7BhB;AA+BY;EACI,eAAA;AA7BhB;AA+BY;EACI,mBAAA;EACA,oBAAA;EACA,gCAAA;AA7BhB;AA8BgB;EACI,aAAA;EACA,mBAAA;AA5BpB;AA+BY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AA7BhB;AA+BY;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA7BhB;AA8BgB;EACI,WAAA;EACA,iBAAA;AA5BpB;AAgCQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AA9BZ;AA+BY;EACI,YAAA;EACA,aAAA;AA7BhB;AA+BY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,sBAAA;AA7BhB;AA+BY;EACI,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AA7BhB;AA+BY;EACI,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AA7BhB;AAgCQ;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA9BZ;AAgCY;EAAO,mBAAA;AA7BnB;AA8BY;EAAO,mBAAA;AA3BnB;AA4BY;EAAO,mBAAA;AAzBnB;AA0BY;EAAO,mBAAA;AAvBnB;AAwBY;EAAO,mBAAA;AArBnB;AAsBY;EAAO,mBAAA;AAnBnB;AAoBY;EAAO,mBAAA;AAjBnB;AAkBY;EAAO,mBAAA;AAfnB;AAgBY;EAAO,mBAAA;AAbnB;AAcY;EAAQ,mBAAA;AAXpB;AAaQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAXZ;AAeI;EACI,aAAA;EACA,sBAAA;AAbR;AAcQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;AAZZ;AAaY;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;AAXhB;AAaY;EACI,gCAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAXhB;AAYgB;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;AAVpB;AAYgB;EACI,YAAA;EACA,cAAA;EACA,4BAAA;AAVpB;AAYgB;EACI,uBAAA;AAVpB;AAaY;EAAM,0CAAA;AAVlB;AAWY;EAAM,wCAAA;AARlB;AASY;EAAM,0CAAA;AANlB;AAOY;EAAM,wCAAA;AAJlB;AAKY;EAAM,0CAAA;AAFlB;AAGY;EAAM,0CAAA;AAAlB;AACY;EAAM,0CAAA;AAElB;AADY;EAAM,wCAAA;AAIlB;AAAY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,8BAAA;AAEhB;AADgB;EACI,gBAAA;AAGpB;AADgB;EACI,YAAA;AAGpB;AADgB;EACI,iBAAA;AAGpB;AADgB;EACI,gBAAA;AAGpB;AAEQ;EACI,mBAAA;AAAZ;AACY;EACI,sBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;AAChB;AAAgB;EACI,kBAAA;AAEpB;AAAgB;EACI,iBAAA;EACA,kBAAA;AAEpB;AAAgB;EACI,iBAAA;AAEpB;AAAgB;EACI,WAAA;AAEpB;AAAgB;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAEpB;AAAgB;EACI,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAEpB;AADoB;EACI,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AAGxB;AAFwB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAI5B;AADoB;EACI,sBAAA;EACA,2BAAA;EACA,uBAAA;AAGxB;AAFwB;EACI,eAAA;EACA,eAAA;AAI5B;AAFwB;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAI5B;AAH4B;EACI,WAAA;EACA,YAAA;AAKhC;AAII;EACI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;AAFR;AAKI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAHR;AAKQ;EACI,eAAA;EACA,mBAAA;AAHZ;AAIY;EACI,aAAA;EACA,sBAAA;AAFhB;AAGgB;EACI,gBAAA;AADpB;AAMQ;EACI,mBAAA;AAJZ;AAQI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;AANR;AASI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAPR;AAUI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AARR;AAWI;EACI,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;AATR;AAUQ;EACI,aAAA;AARZ;AAUQ;EACI,0DAAA;AARZ;AAYI;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AAVR;AAYQ;EACI,sBAAA;EACA,sBAAA;EACA,mBAAA;AAVZ;AAaQ;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AAXZ;AAYY;EACI,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAVhB;AAYY;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;AAVhB;AAcQ;EACI,uBAAA;EACA,sBAAA;EACA,mBAAA;AAZZ;AAaY;EACI,mBAAA;AAXhB;AAeQ;EACI,8BAAA;AAbZ;AAgBQ;EACI,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAdZ;AAiBQ;EACI,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AAfZ;AAiBY;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;AAfhB;AA2BY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAzBhB;AA2BgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAzBpB;AA2BgB;EACI,aAAA;AAzBpB;AA2BgB;EACI,kBAAA;EACA,SAAA;EACA,eAAA;AAzBpB;AA4BgB;EACI,mBAAA;EACA,qBAAA;AA1BpB;AA4BoB;EACI,WAAA;EACA,cAAA;AA1BxB;AA4BoB;EACI,aAAA;AA1BxB;AAgCQ;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AA9BZ;AAgCY;EACI,YAAA;AA9BhB;AAiCY;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AA/BhB;AAkCY;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAhChB;AAiCgB;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;AA/BpB;AAmCY;EACI,kBAAA;EACA,iBAAA;AAjChB;AAkCgB;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AAhCpB;AAoCY;EACI,cAAA;AAlChB;AAsCQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AApCZ;AAsCY;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AApChB;AAuCY;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AArChB;AAuCgB;EACI,2BAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AArCpB;AAuCoB;EACI,cAAA;EACA,kBAAA;AArCxB;AAyCgB;EACI,gBAAA;EACA,cAAA;AAvCpB;AAyCgB;EACI,eAAA;EACA,cAAA;EACA,eAAA;AAvCpB;AA2CY;EACI,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAzChB;AA2CgB;EACI,WAAA;AAzCpB;AA0CoB;EACI,gBAAA;EACA,YAAA;EACA,mBAAA;AAxCxB;AA4CgB;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA1CpB;AA4CoB;EACI,eAAA;EACA,gBAAA;AA1CxB;AA6CoB;EACI,eAAA;AA3CxB;AAgDY;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AA9ChB;AAgDgB;EAEI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AA/CpB;AAkDgB;EACI,eAAA;AAhDpB;AAmDY;EACI,YAAA;AAjDhB;AAkDgB;EACI,iBAAA;EACA,eAAA;AAhDpB;AAiDoB;EACI,YAAA;EACA,eAAA;EACA,kBAAA;AA/CxB;AAqDQ;EACI,oBAAA;EACA,sBAAA;AAnDZ;AAoDY;EACI,YAAA;EACA,mBAAA;EACA,sBAAA;AAlDhB;AAsDQ;EACI,sBAAA;EACA,uBAAA;AApDZ;AAqDY;EACI,YAAA;AAnDhB;AAoDgB;EACI,YAAA;AAlDpB;AAqDgB;EACI,eAAA;EACA,kBAAA;AAnDpB;AAsDgB;EACI,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AApDpB;AAsDgB;EACI,YAAA;EACA,kBAAA;EACA,oCAAA;AApDpB;AAsDgB;EACI,kBAAA;AApDpB;AAsDgB;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AApDpB;AAsDoB;EACI,sBAAA;EACA,WAAA;EACA,yBAAA;AApDxB;AAqDwB;EACI,kBAAA;AAnD5B;AA0DQ;EACI,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAxDZ;AA0DY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAxDhB;AA0DgB;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;AAxDpB;AAyDoB;EACI,YAAA;EACA,oBAAA;AAvDxB;AAmEQ;EACI,2BAAA;AAjEZ;AAmEQ;EACI,wBAAA;AAjEZ;AAsEQ;EACI,2BAAA;AApEZ;AAsEQ;EACI,wBAAA;AApEZ;;AAyEA;EACE,wCAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AAtEF;;AAyEA;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAtEJ;AAwEI;EACI,UAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;AAtER;;AA0EA;EACI,0CAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAvEJ;AAyEI;EACI,aAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;EACA,+BAAA;AAvER;AAyEQ;EACI,aAAA;EACA,WAAA;EACA,sBAAA;AAvEZ;AA0EQ;EACI,eAAA;EACA,mBAAA;EACA,oBAAA;AAxEZ;AA2EQ;EACI,eAAA;EACA,oBAAA;AAzEZ;AA4EQ;EACI,iBAAA;AA1EZ;AA2EY;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AAzEhB;AA0EgB;EAEI,mBAAA;AAzEpB;AA2EgB;EACI,eAAA;AAzEpB;;AAgFA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,wCAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;AA7EJ;;AAiFA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;AA9EJ;;AAiFA;EACI,kBAAA;EACA,WAAA;AA9EJ;;AAiFA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AA9EJ;AAgFI;EACI,6BAAA;AA9ER;;AAkFA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;AA/EJ;AAiFI;EACI,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA/ER;AAiFQ;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AA/EZ;AAkFQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AAhFZ;;AAsFI;EACI,eAAA;AAnFR;;AAuFA;EACI,gBAAA;EACA,mBAAA;AApFJ;;AAuFA;EAEI,gBAAA;EACA,eAAA;EACA,sBAAA;AArFJ;;AAwFA;EACI,iBAAA;EACA,oBAAA;AArFJ;;AAwFA;EACI,eAAA;EACA,kBAAA;AArFJ;AAsFI;EACI,6BAAA;AApFR;;AAwFA;EACI,UAAA;EACA,WAAA;AArFJ","sourcesContent":["html, body, #root {\n    background-color: #fff;\n    margin: 0px;\n    padding: 0px;\n    width: 100%;\n    display: block;\n    overflow: auto;\n    min-height: 100vh;\n}\n\n.App {\n    display: flex;\n    color: #000;\n    height: 100%;\n    flex-direction: column;\n    // background-color: #fff;\n    overflow-y: auto;\n\n    &.bga {\n        background-color: rgba(245, 247, 248, 1);\n    }\n\n    &.afap {\n        min-height: 100vh;\n    }\n\n    .App-header {\n        // height: 150px;\n        height: 75px;\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: flex-end;\n        justify-content: space-between;\n        font-size: calc(10px + 2vmin);\n        color: white;\n        \n\n        .App-logo {\n            height: 52px;\n            width: 193px;\n            cursor: pointer;\n        }\n        &.wel {\n            padding-left: 90px;\n        }\n    }\n\n    h1.mainh {\n        font-family: 'Inter';\n        font-weight: 600;\n        font-size: 40px;\n        margin: 0px !important;\n        line-height: 50px;\n\n        &.bb {\n            font-weight: bolder;\n        }\n\n        &.b2 {\n            margin-bottom: 25px !important;\n        }\n    }\n\n    .err-msg {\n        display: flex;\n        flex-direction: row;\n        text-align: center;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        font-family: 'Inter';\n        margin-top: .5em;\n        padding-top: 4px;\n        padding-bottom: 4px;\n        color: #fff;\n        max-width: 600px;\n        font-size: 14px;\n        font-weight: bold;\n        background-color: #d73030;\n        border-radius: 4px;\n        &.alt {\n            color: #d73030;\n            background-color: #fff;\n        }\n    }\n\n    h3.mainh {\n        margin-bottom: 30px;\n        font-size: 30px;\n        font-weight: bolder;\n        margin-left: 10px;\n    }\n\n    h4.mainh {\n        font-size: 32px;\n        font-weight: 500;\n        margin-left: 0px;\n        margin-bottom: 30px;\n    }\n\n    .mainh.cn {\n        text-align: center;\n    }\n\n    .ebn {\n        width: 75%;\n        max-width: 800px;\n        max-width: 600px;\n        /* min-width: 550px; */\n        border-radius: 6px;\n        height: 60px;\n        outline: none;\n        font-size: 16px;\n        margin-top: 25px;\n        text-align: center;\n        background-color: transparent;\n        border: 1px solid #DDD;\n    }\n\n    .clogos {\n        display: flex;\n        margin-top: 1.2em;\n        margin-bottom: 1.2em;\n        img {\n            height: 35px;\n            margin-left: 1em;\n            margin-right: 1em;\n        }\n    }\n\n    .pp-body{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        &.cn {\n            width: 100%;\n            padding-top: 120px;\n            align-items: center;\n        }\n    }\n    \n    .ssfy {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        margin-top: 1em;\n        margin-bottom: 1em;\n\n        // span {\n        //     background-color: rgba(153, 158, 161, 1);\n        //     color: #fff;\n        //     border-radius: 8px;\n        //     padding: 8px 15px;\n        //     cursor: pointer;\n        //     font-size: 16px;\n        //     margin: 4px 8px;\n        // }\n\n        button {\n            background-color: #5f7380;\n            color: #fff;\n            border-radius: 40px;\n            font-size: 14px;\n            margin: 4px 8px;\n            border: 1px solid #20134b;\n            height: 40px;\n            padding-left: 14px;\n            padding-right: 14px;\n            justify-content: center;\n            align-items: center;\n            display: inline-flex;\n            cursor: pointer;\n\n            &:hover {\n                background-color: #353e44;\n            }\n        }\n    }\n\n\n    .cu-product {\n        display: flex;\n        flex-direction: row !important;\n        justify-content: flex-start !important;\n        align-items: flex-start !important;\n        .cu-main {\n            display: inline-flex;\n            width: 62%;\n            flex-direction: column;\n            &>div {\n                display: flex;\n                width: 100%;\n            }\n        }\n        .cu-head {\n            display: flex;\n            flex-direction: row;\n            padding: 1em 1em 0 1em;\n            &>div {\n                display: inline-flex;\n                flex-direction: column;\n                padding: 5px;\n                color: #999EA1;\n                font-size: 14px;\n                cursor: pointer;\n                justify-content: center;\n                align-items: center;\n                &._1 {\n                    color: #000;\n                }\n            }\n        }\n        .cu-right {\n            display: inline-flex;\n            flex-direction: column;\n            width: 37%;\n            padding: 1em 5px;\n\n            .cu-il {\n                width: 45px;\n                border-radius: 4px;\n                margin-right: 1em;\n                border: 1px solid #E0E0E0;\n            }\n            .cu-ds {\n                font-size: 16px;\n            }\n            .cu-h, .cu-sh {\n                color: #151515;\n                font-size: 28px;\n                margin-top: 10px;\n                margin-bottom: 10px;\n                font-weight: bolder;\n            }\n            .cu-sh {\n                font-size: 20px;\n            }\n            .cu-rw {\n                margin-bottom: 10px;\n                padding-bottom: 10px;\n                border-bottom: 1px solid #EEEEEE;\n                &.rw {\n                    display: flex;\n                    flex-direction: row;\n                }\n            }\n            .btn-rw {\n                display: flex;\n                flex-direction: row;\n                width: 100%;\n                margin-top: 1em;\n                margin-bottom: 1em;\n                justify-content: space-between;\n                align-items: center;\n            }\n            .btn-default {\n                border: 1px solid #151515;\n                width: 152px;\n                height: 37px;\n                display: inline-flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 14px;\n                img {\n                    width: 16px;\n                    margin-right: 8px;\n                }\n            }\n        }\n        .cu-body {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            position: relative;\n            justify-content: center;\n            .ib-m {\n                margin: 25px;\n                height: 420px;\n            }\n            .itl-1, .itl-2 {\n                border-radius: 50%;\n                width: 45px;\n                height: 45px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                background: #fff;\n                cursor: pointer;\n                box-shadow: 1px 2px 3px #DDD;\n                border: 1px solid #DDD;\n            }\n            .itl-1 {\n                position: absolute;\n                background: #F6F6F6;\n                left: 25px;\n                top: 25px;\n            }\n            .itl-2 {\n                position: absolute;\n                background: #2D9CDB;\n                left: 25px;\n                top: 85px;\n            }\n        }\n        .clr {\n            background: #DDD;\n            margin: 5px;\n            border-radius: 50px;\n            width: 20px;\n            cursor: pointer;\n            height: 20px;\n\n            &._1 { background: #FB891F; }\n            &._2 { background: #FB1F1F; }\n            &._3 { background: #C0F000; }\n            &._4 { background: #83D61A; }\n            &._5 { background: #1FD3FB; }\n            &._6 { background: #1958B6; }\n            &._7 { background: #661FFB; }\n            &._8 { background: #590EA5; }\n            &._9 { background: #4F2F00; }\n            &._10 { background: #000000; }\n        }\n        .cut {\n            display: flex;\n            flex-direction: row;\n            padding: 5px 10px;\n            background: #FCF6EA;\n            border-radius: 4px;\n            color: #C89435;\n            cursor: pointer;\n        }\n    }\n\n    .cnp-tab {\n        display: flex;\n        flex-direction: column;\n        .cnp-rw {\n            width: 100%;\n            display: row;\n            display: flex;\n            &.f {\n                align-self: center;\n                flex-direction: row;\n                flex-wrap: wrap;\n                justify-content: space-between;\n                flex: 1;\n            }\n            .cnp-it {\n                text-decoration: none !important;\n                background-color: #ddd;\n                color: #000 !important;\n                border-radius: 4px;\n                height: 270px;\n                width: 270px;\n                margin: 10px;\n                display: flex;\n                cursor: pointer;\n                justify-content: center;\n                align-items: center;\n                span {\n                    font-size: 22px;\n                    font-weight: bolder;\n                    text-align: center;\n                }\n                &.h {\n                    flex-grow: 1;\n                    flex-shrink: 0;\n                    flex-basis: calc(33% - 20px);\n                }\n                &.t {\n                    background: transparent;\n                }\n            }\n            .c1 { background-color: rgba(18, 177, 150, 0.05); }\n            .c2 { background-color: rgba(23, 20, 35, 0.05); }\n            .c3 { background-color: rgba(246, 173, 77, 0.19); }\n            .c4 { background-color: rgba(23, 20, 35, 0.07); }\n            .c5 { background-color: rgba(246, 173, 77, 0.19); }\n            .c6 { background-color: rgba(18, 177, 150, 0.07); }\n            .c7 { background-color: rgba(18, 177, 150, 0.07); }\n            .c8 { background-color: rgba(23, 20, 35, 0.07); }\n        }\n\n        &.alt {\n            .cnp-it {\n                width: 400px;\n                height: 130px;\n                margin-bottom: 2em;\n                border-radius: 1em;\n                position: relative;\n                flex-direction: row;\n                border: 1px solid #DDD;\n                background-color: #fff;\n                justify-content: space-between;\n                span {\n                    margin-left: 1em;\n                }\n                img {\n                    height: 100%;\n                }\n                &.n1 {\n                    margin-right: 1em;\n                }\n                &.n2 {\n                    margin-left: 1em;\n                }\n            }\n        }\n\n        &.alt-2 {\n            margin-bottom: 30px;\n            .cnp-it {\n                flex-direction: column;\n                background-color: #fff;\n                height: auto;\n                width: 300px;\n                justify-content: flex-start;\n                &.t1 {\n                    margin-right: 20px;\n                }\n                &.t2 {\n                    margin-left: 20px;\n                    margin-right: 20px;\n                }\n                &.t3 {\n                    margin-left: 20px;\n                }\n                img {\n                    width: 100%;\n                }\n                strong {\n                    color: #000;\n                    text-align: left;\n                    font-size: 16px;\n                    width: 100%;\n                    padding: 5px 15px;\n                }\n                &>div {\n                    width: calc(100% - 30px);\n                    margin-left: 15px;\n                    margin-right: 15px;\n                    padding-top: 8px;\n                    padding-bottom: 8px;\n                    border-top: 1px solid #DDD;\n                    display: flex;\n                    flex-direction: row;\n                    justify-content: space-between;\n                    span {\n                        font-size: 16px;\n                        color: rgba(153, 158, 161, 1);\n                        font-weight: normal;\n                        display: inline-flex;\n                        align-items: center;\n                        flex-direction: row;\n                        img {\n                            width: 15px;\n                            height: 15px;\n                            margin-right: 5px;\n                        }\n                    }\n                    &.alt {\n                        flex-direction: column;\n                        justify-content: flex-start;\n                        align-items: flex-start;\n                        b {\n                            font-size: 14px;\n                            margin-top: 3px;\n                        }\n                        span {\n                            display: flex;\n                            font-size: 14px;\n                            flex-direction: row;\n                            align-items: center;\n                            margin-bottom: 10px;\n                            img {\n                                width: 14px;\n                                height: 14px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .btn-next {\n        background: #12B196;\n        height: 45px;\n        width: 153px;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        color: #fff !important;\n        font-size: 16px;\n        margin: 10px 0 15px 0;\n        border-radius: 4px;\n        text-decoration: none;\n        border: 1px solid transparent;\n    }\n\n    .wec0 {\n        position: relative;\n        width: calc(100vw / 2);\n        padding: 50px 90px;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n\n        p {\n            font-size: 18px;\n            margin-bottom: 25px;\n            &.clst {\n                display: flex;\n                flex-direction: column;\n                span {\n                    margin-top: 10px;\n                }\n            }\n        }\n\n        &.alt {\n            padding-left: 120px;\n        }\n    }\n\n    .bc-ro {\n        position: absolute;\n        top: 100px;\n        width: 210px;\n        left: calc(50vw - 105px);\n    }\n\n    .bc-ma {\n        position: absolute;\n        width: 100vw;\n        bottom: 100px;\n        color: #fff;\n        height: 50px;\n        display: flex;\n        font-size: 20px;\n        justify-content: center;\n        align-items: center;\n        background: #c16bab;\n    }\n\n    .fright {\n        width: 650px;\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n    }\n\n    .wec1 {\n        background: #91bdb9;\n        width: calc(100vw / 2);\n        min-width: fit-content;\n        display: flex;\n        position: absolute;\n        right: 0px;\n        top: 0px;\n        flex-direction: row;\n        justify-content: center;\n        background-image: linear-gradient(to right, #91bdb9, #99c5c9);\n        .we1 {\n            height: 100vh;\n        }\n        &.alt {\n            background-image: linear-gradient(to right, #fff, #f8f9fa);\n        }\n    }\n\n    .App-body {\n        display: flex;\n        padding-top: 25px;\n        padding-bottom: 50px;\n        flex-direction: row;\n        min-width: 1024px;\n        justify-content: center;\n        \n        &.flex-col {\n            flex-direction: column;\n            justify-content: unset;\n            align-items: center;\n        }\n\n        .pg {\n            display: flex;\n            color: #104FB8 !important;\n            font-weight: 400;\n            font-size: 18px;\n            margin-bottom: 0px;\n            text-decoration: none !important;\n            cursor: pointer;\n            &.cn {\n                width: 100%;\n                text-align: center;\n                justify-content: center;\n                align-items: center;\n            }\n            &.ri {\n                width: 100%;\n                text-align: right;\n                justify-content: flex-end;\n            }\n        }\n\n        &.main-body {\n            justify-content: center;\n            flex-direction: column;\n            align-items: center;\n            &.cr {\n                align-items: center;\n            }\n        }\n\n        &.full {\n            min-height: calc(100vh -  75px);\n        }\n\n        .sign-p {\n            width: 90%;\n            max-width: 600px;\n            padding-left: 1em;\n            padding-right: 1em;\n            text-align: center;\n            font-size: 18px;\n            margin-bottom: 25px;\n        }\n\n        .g-steps {\n            display: flex;\n            width: 320px;\n            justify-content: space-between;\n            flex-direction: row;\n            position: relative;\n            z-index: 1;\n            margin-bottom: 40px;\n\n            &::before {\n                content: '';\n                width: 100%;\n                height: 2px;\n                background: #999EA1;\n                z-index: -1;\n                left: 0px;\n                top: calc(34px / 2);\n                position: absolute;\n            }\n\n            // .nos {\n            //     position: absolute;\n            //     top: 35px;\n            //     display: flex;\n            //     width: 100%;\n            //     justify-content: space-between;\n            //     flex-direction: row;\n            // }\n\n            .g-step {\n                width: 35px;\n                height: 35px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                border-radius: 50%;\n                background: #fff;\n                cursor: pointer;\n                position: relative;\n                border: 2px solid #999EA1;\n\n                div.g-st {\n                    width: 12px;\n                    height: 12px;\n                    background: #999EA1;\n                    border-radius: 50%;\n                }\n                img.g-st {\n                    display: none;\n                }\n                span {\n                    position: absolute;\n                    top: 37px;\n                    font-size: 14px;\n                }\n\n                &:hover, &._active {\n                    background: #12B196;\n                    border-color: #12B196;\n\n                    img.g-st {\n                        width: 14px;\n                        display: block;\n                    }\n                    div.g-st {\n                        display: none;\n                    }\n                }\n            }\n        }\n\n        .gsv-foot {\n            width: 870px;\n            display: flex;\n            position: relative;\n            margin-top: 20px;\n            margin-bottom: 20px;\n            flex-direction: column;\n\n            &.cst {\n                width: 950px;\n            }\n\n            .btn-next {\n                position: absolute;\n                right: 0px;\n                top: 0px;\n            }\n\n            h2 {\n                font-weight: bolder;\n                position: relative;\n                display: block;\n                font-size: 32px;\n                width: fit-content;\n                padding-right: 10px;\n                small {\n                    position: absolute;\n                    font-size: 25px;\n                    color: red;\n                    right: -2px;\n                    top: 0px;\n                }\n            }\n\n            p {\n                position: relative;\n                padding-left: 1em;\n                small {\n                    position: absolute;\n                    font-size: 20px;\n                    color: red;\n                    left: 0px;\n                    top: -2px;\n                }\n            }\n\n            span {\n                color: #999EA1;\n            }\n        }\n\n        .gsv-cover {\n            width: 870px;\n            display: flex;\n            flex-direction: column;\n            background: #F6F6F6;\n            align-items: center;\n            border-radius: 10px;\n\n            &.cst {\n                width: 950px;\n                height: 550px;\n                background-color: #fff;\n            }\n\n            &.ulogo {\n                justify-content: center;\n                border-radius: 25px;\n                margin-top: 40px;\n                height: 300px;\n                width: 650px;\n\n                &.im {\n                    justify-content: flex-start;\n                    height: unset;\n                    padding-top: 2em;\n                    padding-bottom: 2em;\n                    \n                    img {\n                        max-width: 90%;\n                        margin-bottom: 1em;\n                    }\n                }\n\n                b {\n                    margin-top: 25px;\n                    color: #151515;\n                }\n                span {\n                    margin-top: 5px;\n                    color: #999EA1;\n                    font-size: 14px;\n                }\n            }\n\n            &.fill {\n                background-color: #fff;\n                justify-content: flex-start;\n                border-radius: 8px;\n                margin-top: 20px;\n                width: 650px;\n                padding: 20px;\n                margin-bottom: 1em;\n\n                form {\n                    width: 100%;\n                    input {\n                        margin-top: 15px;\n                        height: 60px;\n                        margin-bottom: 15px;\n                    }\n                }\n\n                &.alt {\n                    height: 60px;\n                    margin-top: 20px;\n                    padding-left: 20px;\n                    padding-right: 20px;\n                    justify-content: space-between;\n                    flex-direction: row;\n                    margin-bottom: 20px;\n\n                    b {\n                        font-size: 25px;\n                        font-weight: 400;\n                    }\n\n                    strong {\n                        font-size: 25px;\n                    }\n                }\n            }\n\n            .gsv {\n                margin-top: 1em;\n                margin-bottom: 1em;\n                background-color: #373737;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                border-radius: 6px;\n                width: 833px;\n                height: 390px;\n\n                &.y {\n                    // overflow: hidden;\n                    height: auto;\n                    min-height: 400px;\n                    padding-top: 7px;\n                    border-radius: 10px;\n                    flex-direction: column;\n                }\n\n                img {\n                    cursor: pointer;\n                }\n            }\n            p {\n                width: 833px;\n                &.gsp {\n                    margin-top: .5em;\n                    font-size: 20px;\n                    img {\n                        height: 40px;\n                        margin-top: 5px;\n                        margin-bottom: 5px;\n                    }\n                }\n            }\n        }\n\n        .rf-sect, .md-sect {\n            display: inline-flex;\n            flex-direction: column;\n            &.step-1 {\n                width: 600px;\n                padding: 25px 100px;\n                border: 1px solid #DDD;\n            }\n        }\n        \n        .rf-sect {\n            flex-direction: column;\n            justify-content: center;\n            form {\n                width: 400px;\n                &.rest-form {\n                    width: 500px;\n                }\n\n                &>* {\n                    margin-top: 1em;\n                    margin-bottom: 1em;\n                }\n\n                label:not(.form-check-label) {\n                    font-family: 'Inter';\n                    font-weight: 400;\n                    margin-bottom: 5px;\n                    font-size: 18px;\n                }\n                input:not(.form-check-input) {\n                    height: 57px;\n                    border-radius: 4px;\n                    border: 1px solid #E0E0E0 !important;\n                }\n                .form-check {\n                    margin-bottom: 0px;\n                }\n                .submit-btn {\n                    height: 57px;\n                    margin-bottom: 0px;\n                    border-radius: 4px;\n                    background-color: #12B196;\n                    color: #fff;\n                    font-size: 18px;\n                    width: 100%;\n\n                    &.btn-default {\n                        background-color: #fff;\n                        color: #000;\n                        border: 1px solid #999EA1;\n                        .gvg {\n                            margin-right: 14px;\n                        }\n                    }\n                }\n            }\n        }\n        \n        .md-sect {\n            margin-left: 12%;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n\n            .md-sect-cover {\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                justify-content: center;\n            \n                .md-rw {\n                    width: 200px;\n                    height: 636px;\n                    display: flex;\n                    justify-content: space-around;\n                    align-items: center;\n                    flex-direction: column;\n                    img {\n                        width: 183px;\n                        display: inline-flex;\n                        \n                        &.mt1 {\n                            // margin-top: 1em;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    form.for-step-0 {\n        .for-step-0 {\n            display: inherit !important;\n        }\n        .for-step-1 {\n            display: none !important;\n        }\n    }\n\n    form.for-step-1 {\n        .for-step-1 {\n            display: inherit !important;\n        }\n        .for-step-0 {\n            display: none !important;\n        }\n    }\n}\n\n.label {\n  font-family: \"Source Sans 3\", sans-serif;\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.fgroup {\n    display: flex;\n    margin: 10px 0px;\n    height: 60px;\n    border: 1px solid #DDD;\n    padding-left: 10px;\n    border-radius: 8px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    span.ftd {\n        width: 50%;\n        border-left: 1px solid #DDD;\n        height: 100%;\n        padding-left: 1.5em;\n        display: inline-flex;\n        justify-content: flex-start;\n        align-items: center;\n        flex-direction: row;\n        border-top-right-radius: 8px;\n        border-bottom-right-radius: 8px;\n    }\n}\n\n.modal-bg {\n    background-color: rgba(187, 185, 185, 0.4);\n    position: fixed;\n    display: flex;\n    bottom: 0px;\n    right: 0px;\n    left: 0px;\n    top: 0px;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n\n    .modal-pp {\n        height: 500px;\n        width: 1000px;\n        max-width: 90%;\n        padding: 2em;\n        background: #fff;\n        border: 1px solid #ddd;\n        display: inline-flex;\n        flex-direction: column;\n        overflow: auto;\n        box-shadow: 1px 2px 3px #868686;\n\n        .flex-contnt {\n            display: flex;\n            width: 100%;\n            flex-direction: column;\n        }\n\n        h2 {\n            font-size: 35px;\n            font-weight: bolder;\n            margin-bottom: 0.7em;\n        }\n\n        p {\n            font-size: 18px;\n            margin-bottom: 0.9em;\n        }\n\n        .modal-ul {\n            padding-left: 0px;\n            li {\n                display: flex;\n                flex-direction: column;\n                margin-bottom: 1.2em;\n                & > b, & > span {\n                    // font-size: 18px;\n                    margin-bottom: 10px;\n                }\n                & > b {\n                    font-size: 18px;\n                }\n            }\n        }\n    }\n}\n\niframe.onb-can {\n    width: 100%;\n    display: flex;\n    height: 624px;\n    border-top: 1px solid rgb(221, 221, 221);\n    padding-top: 10px;\n    padding-bottom: 10px;\n    margin-top: 10px;\n    background: #fff;\n    border-bottom: 1px solid rgb(221, 221, 221);\n}\n\n\niframe.dash-can {\n    width: 100%;\n    display: flex;\n    height: 624px;\n    border: 1px solid rgb(221, 221, 221);\n    margin-top: 10px;\n    background: #fff;\n}\n\n.tcent {\n    text-align: center;\n    width: 100%;\n}\n\n.rest-rect {\n    width: 500px;\n    display: flex;\n    flex-direction: column;\n    padding: 30px 70px;\n    background-color: #F4F4F4;\n    border-radius: 2em;\n\n    input {\n        background-color: transparent;\n    }\n}\n\n.reset-pop-up {\n    display: flex;\n    position: fixed;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.35);\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000000000;\n\n    .reset-pop {\n        width: 500px;\n        padding: 50px 25px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        border-radius: 25px;\n        background-color: #ddd;\n\n        img {\n            cursor: pointer;\n            background: #DDD;\n            height: auto;\n            width: 270px;\n        }\n\n        strong {\n            text-align: center;\n            font-size: 25px;\n            margin-top: 25px;\n        }\n    }\n}\n\n.rest-form {\n    label {\n        margin-top: 8px;\n    }\n}\n\nh4.tcent {\n    font-weight: 600;\n    margin-bottom: 20px;\n}\n\np.tcent {\n    // font-family: Source Sans Pro;\n    font-weight: 400;\n    font-size: 16px;\n    padding: 5px 50px 10px;\n}\n\n.dash-can.pa {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n#ulogo-preview {\n    cursor: pointer;\n    margin-bottom: 2em;\n    &.alt {\n        margin-bottom: 0px !important;\n    }\n}\n\n*::-webkit-scrollbar {\n    width: 4px;   // for vertical scroll bar\n    height: 4px;  // for horizontal scroll bar\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
